import '../../utils/index.mjs';
import CollapseTransition from './src/collapse-transition.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCollapseTransition = withInstall(CollapseTransition);

export { ElCollapseTransition, ElCollapseTransition as default };
//# sourceMappingURL=index.mjs.map
